<template>
  <span>{{formattedDate}}</span>
</template>

<script>
export default {
  name: 'date-display',
  props: {
    date: {
      type: String,
      required: true
    },
  },
  computed: {
    formattedDate(){
      return new Date(this.date).toLocaleDateString('en-GB')
    }
  },
}
</script>

<style lang="scss">
  .date-display {

  }
</style>
